import classNames from 'classnames';
import React from 'react';

import Icon from 'components/Icon';
import { IconType } from 'components/Icon/constants';
import { AssetActionsProps } from './models';
import styles from './styles.module.scss';

const AssetActions: React.FunctionComponent<AssetActionsProps> = (props) => {
  const { onDelete, onPreviewOpen, assetClickable = false, hasDelete = true, dataTestId = 'assetActions' } = props;

  return (
    <div className={classNames(styles.AssetActions, { [styles.clickable]: assetClickable })} data-testid={dataTestId}>
      <div className={styles.icons} data-testid={`${dataTestId}-icons`}>
        {!!onPreviewOpen && (
          <Icon
            type={IconType.VIEW_DETAILS}
            size="sm"
            color="secondary"
            className={styles.viewDetails}
            onClick={onPreviewOpen}
            dataTestId={`${dataTestId}-icons`}
          />
        )}
        {!!onDelete && hasDelete && (
          <Icon
            type={IconType.DELETE_BIN}
            size="badge"
            color="secondary"
            className={styles.deleteBin}
            onClick={onDelete}
            dataTestId={`${dataTestId}-icons`}
          />
        )}
      </div>
    </div>
  );
};

export default AssetActions;
